import { animationKeys } from './animations';
import { displayKeys } from './display';
import { flexboxKeys } from './flexbox';
import { gridKeys } from './grid';
import { heightKeys } from './height';
import { marginKeys } from './margin';
import { overflowKeys } from './overflow';
import { paddingKeys } from './padding';
import { positionKeys } from './position';
import { shadowElevationKeys } from './shadowElevation';
import { textDecorationKeys } from './textDecoration';
import { whitespaceKeys } from './whitespace';
import { widthKeys } from './width';
const styleKeys = [
    ...animationKeys,
    ...displayKeys,
    ...flexboxKeys,
    ...gridKeys,
    ...heightKeys,
    ...marginKeys,
    ...overflowKeys,
    ...paddingKeys,
    ...positionKeys,
    ...shadowElevationKeys,
    ...textDecorationKeys,
    ...whitespaceKeys,
    ...widthKeys,
];
const styleKeysSet = new Set(styleKeys);
/**
 * Omit Design System's style props (e.g. margin, padding, position, etc.) from a full set of props.
 * This is useful when you want to pass all props to a child component without passing the style props.
 *
 * @param props - The full set of props including style props and other props
 * @returns The set of props excluding style props
 * @example
 * ```tsx
 * const MyComponent = (props: MyComponentProps) => {
 *    const otherProps = omitStyleProps(props)
 *    return <div {...otherProps} />
 * }
 * ```
 */
export function omitStyleProps(props) {
    const remainingEntries = Object.entries(props).filter(([key]) => !styleKeysSet.has(key));
    return Object.fromEntries(remainingEntries);
}
